<template>
  <result-item-template
    :name="result.item.name"
    icon-glyph="FISHING_SPOT"
    :image-url="resultImage()"
  >
    <template #metadata>
      <ys-text
        type="metadata1"
        class="result-details-subtext"
        data-test="search-result-subtext"
      >
        <div>
          <span v-if="result.about?.name">
            {{ result.about.name }}
          </span>
          <span v-if="result.about?.name" class="divider">|</span>
          <span>{{ result.about?.waterbody?.name }}</span>
        </div>
        <div>
          <span v-if="cityState">
            {{ cityState }}
          </span>
        </div>
      </ys-text>
    </template>
  </result-item-template>
</template>

<script setup lang="ts">
///// imports /////
import { computed } from 'vue'
import '@onxmaps/yellowstone-ui/ys-text'
import { getCityState } from '@/lib/search/search-utils'
import resultItemTemplate from '@/components/search/result-items/result-item-template.vue'

import type { SearchResultProps } from '@/services/search-service/types'
import type { FishingArea } from '@onxmaps/supergraph'

///// types /////
// Special SearchResultProps variant denoted as a FishingArea result
interface FishAreaSearchResult extends SearchResultProps {
  about: FishingArea
}
interface FishingAreaItemProps {
  result: FishAreaSearchResult
}

///// props/emits /////
const { result } = defineProps<FishingAreaItemProps>()

///// computed /////
const cityState = computed(() => getCityState(result))

///// functions /////
const resultImage = () => {
  return result.about?.coverPhoto?.contentUrl ?? undefined
}
</script>

<style lang="scss" scoped>
.divider {
  padding: 0 var(--ys-spacing-25);
}
</style>
